<template>
  <b-modal
    v-model="estatusModal"
    modal-class="modal-save-as"
    size="xl"
    title="Guardar Como ..."
    id="modal-ubication"
    class="cme-modal"
    ref="modal-ubication"
    @hide="offPropOpen"
  >
    <b-row class="row-modal">
      <b-col cols="2" class="bg-dark p-0">
        <p
          class="p-2 border-bottom"
          style="text-align: center; font-weight: bold; margin-bottom: 0;"
        >Mis Cursos</p>
        <b-nav vertical class="cursos">
          <b-nav-item
            v-for="c in cursos"
            :key="c._id"
            :active="c.active"
            @click="changeDataDir(c,true)"
            class="item-modal"
          >
            <i class="nav-icon icon-folder-alt mr-1 text-secondary"></i>
            {{ c.name }}
          </b-nav-item>
        </b-nav>
      </b-col>
      <b-col>
        <b-col cols="12">
          <b-form-input
            v-model="materialName"
            class="mt-2 form-control"
            placeholder="Nombre del archivo"
          ></b-form-input>
        </b-col>
        <b-col cols="12">
          <DirectoriosContent
            :show-buttons="false"
            v-if="cursos"
            :data-dir="dirObj"
            :records="recordsDir"
            @change-dir="changeDataDir($event)"
            @return-dir="returnDir($event)"
          />
        </b-col>
      </b-col>
    </b-row>
    <div slot="modal-footer">
      <b-button variant="primary" class="mr-2" @click="saveMaterial">Guardar</b-button>
      <b-button @click="estatusModal = false">Cancelar</b-button>
    </div>
  </b-modal>
</template>

<script>
function strip_html_tags(str) {
  if (str === null || str === "") {
    return false;
  } else {
    str = str.toString();
    str = str.replace(/&nbsp;/gi, "");
    str = str.replace(/<[^>]*>/gi, "");
    return str;
  }
}
import DirectorioService from "@/services/directorio.service";
import MaterialService from "@/services/material.service";
import DirectoriosContent from "@/components/DirectoriosContent";
export default {
  name: "modal-save-as",
  data() {
    return {
      dirObj: {},
      recordsDir: new Array(),
      paramsDir: {
        paginate: true,
        filtro: {
          father: null,
          author: null,
          estatus: "ACTIVO"
        }
      },
      dataPagination: {},
      user: {},
      estatusModal: false,
      materialName: ""
    };
  },
  components: {
    DirectoriosContent
  },
  props: {
    target: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    offPropOpen() {
      this.$emit("ModalSaveAsClosed");
    },
    getListDocs(page) {
      this.recordsDir = new Array();
      this.paramsDir.filtro.father = this.dirObj._id;
      DirectorioService.list(page, this.paramsDir).then(response => {
        this.dataPagination = JSON.parse(JSON.stringify(response));
        delete this.dataPagination.docs;
        response.docs.forEach(rec => {
          rec["typeRec"] = "dirs";
          this.recordsDir.push(rec);
        });
      });
    },
    changeDataDir(dir, isCurso = false) {
      this.paramsDir.filtro.father = dir._id;
      this.dirObj = dir;
      if (isCurso) {
        this.cursos.forEach((c, i, a) => {
          c.active = false;
          if (i == a.length - 1) dir["active"] = true;
        });
      }
      this.getListDocs(1);
    },
    saveMaterial() {
      if (this.materialName != "" && this.materialName != null) {
        var materialTree = JSON.parse(JSON.stringify(this.dirObj.tree));
        var indexEndRoute = materialTree.length - 1;
        if (indexEndRoute == -1) {
          materialTree.push({});
          indexEndRoute = 0;
        }
        materialTree[indexEndRoute]["idDir"] = this.dirObj._id;

        MaterialService.list(1, this.paramsDir)
          .then(response => {
            let dataMaterial = this.$store.getters[
              "constructor/getActivityData"
            ];
            var data = dataMaterial.info;
            (data.father = this.dirObj._id),
              (data.tree = materialTree),
              (data.orden = response.totalDocs + 1);
            data["content"] = dataMaterial.content;
            data["name"] = this.materialName || strip_html_tags(data.title); // ACA
            return MaterialService.save(data);
          })
          .then(response => {
            this.$root.triggetSuccessMgs(
              "Excelente",
              "Se ha guardado correctamente"
            );
            delete response.content;
            const infoMaterial = JSON.parse(JSON.stringify(response));
            this.$store.dispatch("constructor/setInfo", infoMaterial);
            this.estatusModal = false;
          });
      } else {
        this.$root.triggerWarnMgs("Debes Agregar un Nombre al Archivo","");
      }
    }
  },
  watch: {
    target: function(change) {
      if (change) {
        this.$refs["modal-ubication"].show();
        if (this.cursos) {
          this.dirObj = this.cursos[0];
          this.cursos[0]["active"] = true;
          this.getListDocs(1);
        }
        this.estatusModal = true;
      }
    }
  },
  computed: {
    cursos: function() {
      return this.$store.getters["directorio/getListCursos"];
    }
  },
  created() {
    this.user = this.$store.getters["auth/infoUser"];
    this.paramsDir.filtro.author = this.user._id;
  }
};
</script>

<style lang="scss">
#modal-ubication {
  .modal-dialog {
    .modal-content {
      .modal-header {
        border-bottom: solid 1px #ccc;
        color: #fff;
        background-color: #13322b;
        font-weight: bold !important;
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        .modal-title {
          font-weight: bold;
        }
        .close {
          color: #ffffff;
        }
      }
      .modal-body {
        padding: 0 1rem;

        .row-modal {
          min-height: 50vh;
        }

        .cursos {
          .nav-item {
            a {
              color: #fff;
            }
            &:hover,
            .active {
              background: #20a8d8;
            }
          }
        }
      }
    }
  }
}
.bg-dark {
  background-color: #285c4d !important;
}
li.nav-item {
  padding: 0 !important;
}
.item-modal > .nav-link.active {
  background-color: #13322b !important;
}
.item-modal > .nav-link:hover {
  background-color: #13322b !important;
}
.text-secondary {
  color: #fff !important;
}
.nav-link {
  color: #d4c19c;
}
</style>